module.exports = __webpack_public_path__ + "img/module6.badc14d7.png";